"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListDeployButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const deployWaitList_json_1 = __importDefault(require("@framework/abis/json/WaitListFactoryFacet/deployWaitList.json"));
const WaitListDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (_values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployWaitList_json_1.default,
            functionName: "deployWaitList",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = () => {
        return handleDeployConfirm({
            url: "/contract-manager/wait-list",
            method: "POST",
            data: {},
        }, {});
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: onDeployConfirm, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "WaitlistDeployButton", disabled: disabled, variant: variant }));
};
exports.WaitListDeployButton = WaitListDeployButton;
//# sourceMappingURL=index.js.map